import * as types from './action-types';

const baseState = {
    hasError: false,
    error: null,
    fetching: false,
};

const defaultState = {
    ...baseState,
    emailUpdateData: {},
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
    case types.EMAIL_UPDATE_PENDING:
        return Object.assign({}, state, baseState, {
            fetching: true,
        });

    case types.EMAIL_UPDATE_FAILED:
        return Object.assign({}, state, baseState, {
            hasError: true,
            error: action.error,
        });

    case types.EMAIL_UPDATE_SUCCESS:
        return Object.assign({}, state, baseState, {
            emailUpdateData: action.res.data,
        });

    default:
        return Object.assign({}, state);
    }
};

export default reducer;
